import React, { useEffect, useState } from 'react'
import { Select } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { equals, map } from 'ramda'
import { useTranslation } from 'react-i18next'
import { getOptions, getUserValue } from '../utils'
import { fetchFunds } from '../../api'
import { usePresetValue } from '../../utils/hooks'

const ExternalSelectFunds = ({ label, name, additionalInfo, showLabelAsPlaceholder }) => {
  const { t, i18n } = useTranslation()
  const [value, setValue] = useState('')
  const [list, setList] = useState('')
  const [isValid, setIsValid] = useState(null)
  const [{ user, form: { accId } }, dispatch] = useStore()
  const userValue = getUserValue(accId, user, name)

  /**
   * @param {number} value
   */
  const presetValue = (value) => {
    const stringValue = value.toString()
    setValue(stringValue)
    const isValid = stringValue.length > 0
    setIsValid(isValid)
    dispatch({ type: 'setExtFieldValue', name, value: value })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  usePresetValue(name, userValue, presetValue)

  useEffect(() => {
    fetchFunds().then(
      /**
      * @param {OptionsInput[]} employment
      */
      (employment) => {
        setList(getOptions(employment))
      })
  }, [i18n.language])

  /**
   * @param {string} value
   */
  const getSelectValue = (value) => (equals(value, t('generatedField.choose')) ? '' : value)

  const onChange = ({ target: { value, name } }) => {
    const selectedValue = getSelectValue(value)
    setValue(selectedValue)
    setIsValid(!!selectedValue.length)

    dispatch({
      type: 'setExtFieldValue',
      name,
      value: +selectedValue
    })

    dispatch({
      type: 'setValidationFld',
      name,
      value: selectedValue.length > 0
    })
  }

  return (
    <Select
      value={value || ''}
      label={t(label)}
      placeholder={t('generatedField.choose')}
      options={list}
      onChange={onChange}
      name={name}
      key={name}
      error=''
      valid={isValid}
      info={additionalInfo ? t(`generatedField.${name}AdditionalInfo`) : ''}
      showLabelAsPlaceholder={showLabelAsPlaceholder}
    />
  )
}

const getExternalFundsFields = map(fundsField => {
  const { i18n, name, required, order, additionalInfo } = fundsField
  return (
    <ExternalSelectFunds
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      additionalInfo={additionalInfo}
      required={required}
      key={name}
      order={order}
    />
  )
})

export { ExternalSelectFunds, getExternalFundsFields }
